import { StopFilled, StopTwoTone, VideoCameraAddOutlined, VideoCameraOutlined } from '@ant-design/icons'
import { Badge, Button, Card, Tag } from 'antd'
import React, { useState } from 'react'
import { ReactMediaRecorder } from 'react-media-recorder'
import { baseURL_R } from 'services/BaseUrl'
import { ubahText } from 'services/Crypto'
import { Button_ } from 'services/Forms/FormsSatu'
import { globalText } from 'services/Text/GlobalText'





function ScreenRecorder(pr) {



    const [mp4Url, setMp4Url] = useState(null);
    const [isConverting, setIsConverting] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [videoUrl, setVideoUrl] = useState(null);

    // const convertToMP4 = async (mediaBlobUrl) => {
    //     if (!ffmpeg.isLoaded()) {
    //         await ffmpeg.load();
    //     }
    //     setIsConverting(true);

    //     const inputName = "recording.webm";
    //     const outputName = "recording.mp4";

    //     ffmpeg.FS("writeFile", inputName, await fetchFile(mediaBlobUrl));
    //     await ffmpeg.run("-i", inputName, "-c:v", "libx264", "-preset", "fast", outputName);
    //     const data = ffmpeg.FS("readFile", outputName);

    //     const videoBlob = new Blob([data.buffer], { type: "video/mp4" });
    //     const videoUrl = URL.createObjectURL(videoBlob);
    //     setMp4Url(videoUrl);
    //     setIsConverting(false);
    // };




    const uploadVideo = async (blobUrl) => {
        let auth = sessionStorage.getItem(globalText.x_auth_access_token);
        setUploading(true);
        const blob = await fetch(blobUrl).then((r) => r.blob());
        const formData = new FormData();
        formData.append("video", blob, "recording.mp4");
        formData.append("konseling_id", pr.konseling_id);

        try {
            const response = await fetch(baseURL_R + "/upload-bukti-rekaman", {
                method: "POST",
                body: formData,
                headers: {
                    Authorization: `Bearer ${ubahText(auth)}`,
                },
            });

            const data = await response.json();
            if (response.ok) {
                setVideoUrl(data.video_url);
                alert("Video berhasil diunggah!");
            } else {
                alert(data.message || "Upload gagal");
            }
        } catch (error) {
            console.error("Error uploading video:", error);
        }
        setUploading(false);
    };

    return (
        <ReactMediaRecorder
            screen
            render={({ status, startRecording, stopRecording, mediaBlobUrl }) => (
                <div>
                    <hr />
                    <div className='posisirekam'>
                        Status: &nbsp;
                        <Tag className={status === "recording" ? 'blink_me' : ''}
                            color={status === "recording" ? 'green' : 'red'}
                            style={{ textTransform: "uppercase" }}>
                            <VideoCameraOutlined />
                            <b> {status}</b>
                        </Tag>

                        {status !== "recording" ? (
                            <Button size="small" icon={<VideoCameraAddOutlined />} onClick={startRecording} type='primary'>
                                Mulai Rekam Layar
                            </Button>
                        ) : (
                            <Button size='small' danger onClick={() => {
                                stopRecording()
                                setTimeout(() => {
                                    uploadVideo(mediaBlobUrl)
                                }, 500);
                            }
                            } type='primary'>
                                Stop
                            </Button>
                        )}
                        &nbsp;
                        {videoUrl && (
                            <Button type='primary' size='small'>
                                <a href={videoUrl} target="_blank" rel="noopener noreferrer">
                                    Lihat Video
                                </a>
                            </Button>
                        )}

                    </div>



                    <center>
                        {mediaBlobUrl && (
                            <div title="Hasil Rekaman" style={{ width: "80%" }}>
                                {/* <video style={{ width: "100%" }} className='rounded' src={mp4Url || mediaBlobUrl} controls autoPlay /> */}


                            </div>
                        )}
                    </center>
                </div>
            )}
        />
    );


}

export default ScreenRecorder